import React from 'react';
import AiSecurityTool from './components/AiSecurityTool';

function App() {
  return (
    <div className="App">
      <AiSecurityTool />
    </div>
  );
}

export default App;